import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Input, Button, Card, Typography, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { loginStart, loginSuccess, loginFailure } from '../../../../Store/authSlice';
import { loginAPI } from '../../../../Service/authService';
import bgImage from '../../../../Assets/educational_login_bg.png';
import logoGif from '../../../../Assets/vedika_logo.gif';
import '../../../../Assets/css/LoginPage.css';

const { Text } = Typography;

const LoginPage = () => {
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.auth);

  const onFinish = async (values) => {
    dispatch(loginStart());
    try {
      const result = await loginAPI(values.username, values.password);
      dispatch(loginSuccess({ token: result.token, user: result.user }));
      message.success('Welcome back! Login successful.');
    } catch (err) {
      dispatch(loginFailure(err.message || 'Login failed'));
      message.error(err.message || 'Login failed');
    }
  };

  return (
    <div className="login-container" style={{ backgroundImage: `url(${bgImage})` }}>
      <div className="login-background-overlay" />
      <Card className="login-card" bordered={false}>
        <div className="login-header">
          <img src={logoGif} alt="Vedika" className="login-logo" />
        </div>

        <Form
          name="login_form"
          layout="vertical"
          onFinish={onFinish}
        >
          <Form.Item
            name="username"
            rules={[{ required: true, message: 'Please enter your username!' }]}
          >
            <Input 
              prefix={<UserOutlined className="site-form-item-icon" />} 
              placeholder="Username" 
              size="large"
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: 'Please enter your password!' }]}
          >
            <Input.Password
              prefix={<LockOutlined className="site-form-item-icon" />}
              placeholder="Password"
              size="large"
            />
          </Form.Item>

          {error && (
            <div className="login-error-msg">
              <Text type="danger">{error}</Text>
            </div>
          )}

          <Form.Item>
            <Button 
              type="primary" 
              htmlType="submit" 
              className="login-form-button" 
              size="large" 
              loading={loading}
              block
            >
              Sign In
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default LoginPage;
